import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-background-50 text-lg"></i>
                </div>
                <span className="text-background-50 font-bold text-lg font-heading">{siteInfo.name}</span>
              </Link>
              <p className="text-secondary-300 text-sm leading-relaxed mb-4">
                国内领先的韩国漫画在线阅读平台，海量无删减韩漫资源，每日更新，下拉式阅读，高清全彩，完全免费。
              </p>
              <div className="flex items-center gap-3">
                <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href={siteInfo.socialLinks.bilibili} target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
                <a href={siteInfo.socialLinks.zhihu} target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-zhihu-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 text-sm font-semibold mb-4 uppercase tracking-wider font-label">快速导航</h4>
              <div className="flex flex-col gap-3">
                {[
                  { to: '/', label: '首页' },
                  { to: '/category/romance', label: '漫画分类' },
                  { to: '/#ranking', label: '热门排行' },
                  { to: '/#latest', label: '最新更新' },
                  { to: '/about', label: '关于我们' },
                ].map((link) => (
                  <Link key={link.to} to={link.to} className="text-secondary-300 text-sm hover:text-background-50 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-background-50 text-sm font-semibold mb-4 uppercase tracking-wider font-label">热门分类</h4>
              <div className="flex flex-col gap-3">
                {[
                  { to: '/category/romance', label: '恋爱漫' },
                  { to: '/category/action', label: '热血漫' },
                  { to: '/category/fantasy', label: '奇幻漫' },
                  { to: '/category/bl', label: 'BL漫' },
                  { to: '/category/thriller', label: '悬疑漫' },
                ].map((link) => (
                  <Link key={link.to} to={link.to} className="text-secondary-300 text-sm hover:text-background-50 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-background-50 text-sm font-semibold mb-4 uppercase tracking-wider font-label">联系我们</h4>
              <div className="flex flex-col gap-3 text-secondary-300 text-sm">
                <div className="flex items-center gap-2">
                  <i className="ri-mail-line text-base"></i>
                  <span>{siteInfo.contact.email}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-wechat-line text-base"></i>
                  <span>{siteInfo.contact.wechat}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-base"></i>
                  <span>{siteInfo.contact.address}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-secondary-800">
            <div className="text-center">
              <div className="text-6xl md:text-8xl font-extrabold text-secondary-800/50 font-label tracking-tighter select-none mb-6">
                073MH
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-secondary-400 text-xs">
                <span>&copy; 2026 {siteInfo.name} 版权所有</span>
                <span className="hidden sm:block">·</span>
                <a href="#" className="hover:text-background-50 transition-colors">用户协议</a>
                <span className="hidden sm:block">·</span>
                <a href="#" className="hover:text-background-50 transition-colors">隐私政策</a>
                <span className="hidden sm:block">·</span>
                <a href="#" className="hover:text-background-50 transition-colors">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}